import polyglotI18nProvider from 'ra-i18n-polyglot';
import { russianMessages } from './ru';
import { englishMessages } from './en';
import { portugueseMessages } from './pt';

// Доступные языки
export const availableLanguages = [
  { locale: 'ru', name: 'Русский' },
  { locale: 'en', name: 'English' },
  { locale: 'pt', name: 'Português' },
];

// Сообщения для каждого языка
const messages = {
  ru: russianMessages,
  en: englishMessages,
  pt: portugueseMessages,
};

// Создаем провайдер интернационализации без автоматического переключателя
export const i18nProvider = polyglotI18nProvider(
  (locale: string) => messages[locale as keyof typeof messages],
  'ru' // Язык по умолчанию, без списка языков чтобы отключить встроенный переключатель
);

// Получение текущего языка из localStorage
export const getLanguage = (): string => {
  return localStorage.getItem('locale') || 'ru';
};

// Сохранение языка в localStorage
export const setLanguage = (locale: string): void => {
  localStorage.setItem('locale', locale);
};

// Хук для переводов (если нужно использовать вне React Admin)
export const useTranslations = () => {
  const locale = getLanguage();
  const translate = (key: string, options?: any) => {
    const message = messages[locale as keyof typeof messages];
    const keys = key.split('.');
    let value: any = message;
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value === 'string' && options) {
      return value.replace(/%\{(\w+)\}/g, (match, key) => options[key] || match);
    }
    
    return value || key;
  };
  
  return { translate, locale };
};
